import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {AbstractControl, AsyncValidatorFn, FormControl, FormGroup, ValidationErrors, Validators} from "@angular/forms";
import {Observable, of} from "rxjs";
import {environment} from "projects/store/src/environments/environment";
import {CustomMessageService, UtilService, ResponseHttpError, ResponseHttpSuccess, LocalStorageService, OriginMessageError} from "library";
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {UserValidatorService} from "projects/store/src/app/services/api/v1/user-validator.service";
import {ActivatedRoute, Router} from "@angular/router";
import {LocalStorageKey, toOptionArray} from "projects/store/src/app/enums";
import {HttpStatusCode} from "@angular/common/http";
import {SalesWorkflowService} from "projects/store/src/app/services/api/v1/sales-workflow.service";
import {NotificationOtpService} from 'projects/store/src/app/services/api/v1/notification-otp.service';
import {MacroFlowService} from 'projects/store/src/app/services/api/v1/macro-flow.service';

export enum Gender {
  'M' = 'Masculino',
  'F' = 'Femenino',
}

@Component({
  selector: 'app-sales-client-identification-general',
  templateUrl: './sales-client-identification-general.component.html'
})
export class SalesClientIdentificationGeneralComponent implements OnInit {
  form!: FormGroup;
  submitted: boolean = false;
  loading: boolean = false;
  viewSuccess = false;
  viewTopUpLoan = false;
  viewForm = true;
  requestID: any;
  documentTypeList: {label: string, value: string}[] = environment.global.country.documentTypeOptions;
  country: any = environment.global.country;
  genderType: any;
  embed: string;
  data: any;
  srcLogo = `assets/images/${environment.global.country.code}/krediya-logo.svg`;
  showOtpServiceModal = false;
  selectedOtpService!: string | null;
  displayedOtpService!: string | null;
  otpServicesOptions: any[] = [];
  typeSales: string | null = null;
  copyClipboardButtonLabel = 'Copiar información';
  flowCode: string;
  emailRequired: boolean;


  @Output() nextStepEvent = new EventEmitter();

  constructor(private utilService: UtilService,
              private customMessageService: CustomMessageService,
              private requestService: RequestService,
              private userValidatorService: UserValidatorService,
              private localStorageService: LocalStorageService,
              private router: Router,
              private route: ActivatedRoute,
              private salesWorkflowService: SalesWorkflowService,
              private notificationOtpService: NotificationOtpService,
              private macroFlowService: MacroFlowService) {

    this.flowCode = this.route.snapshot.params['flow_code'];

    this.form = new FormGroup({
      document_id_type: new FormControl(null, [Validators.required]),
      document_id_number: new FormControl(null, [Validators.required]),
      phone: new FormControl(null, {
        validators: [Validators.required, Validators.minLength(environment.global.country.minPhoneNumberCharacters)],
        asyncValidators: [this.userValidatorService.phoneServiceExistValidator(this.requestID), userValidatorService.phoneServiceVerification()],
        updateOn: 'blur'
      }),
      gender: new FormControl(null, [Validators.required]),
      country_code_number: new  FormControl(environment.global.country.phoneCountryCode.replace('+', '')),
      email: new FormControl(null, {
        validators: this.getEmailValidators(),
        asyncValidators: this.getEmailAsyncValidators(),
        updateOn: 'blur'
      })
    });

    this.emailRequired = !this.macroFlowService.isExperanzaFlow(this.flowCode);
    this.initForm();
    this.genderType = toOptionArray(Gender);
    this.embed = this.route.snapshot.queryParams['embed'];

    this.flowCode = this.route.snapshot.params['flow_code'];

    const token = this.route.snapshot.queryParams['token'];
    if (token !== undefined) {
      this.localStorageService.set(LocalStorageKey.salesToken, token);
    }

    this.localStorageService.remove(LocalStorageKey.salesData)

    const externalSite = this.route.snapshot.queryParams['external_site'];
    const externalCallbackUrl = this.route.snapshot.queryParams['external_callback_url'];
    if (externalSite !== undefined) {
      const data = {
        external_site: externalSite,
        external_callback_url: externalCallbackUrl
      };
      this.localStorageService.set(LocalStorageKey.salesData, data);
    }

    this.localStorageService.remove(LocalStorageKey.salesData);
    this.utilService.disablePageLoading();

  }

  ngOnInit(): void {
   this.route.queryParams.subscribe( params => {
     this.typeSales = params['type_sales'];
   })
    console.log(this.typeSales)
    setTimeout(() => this.showGetOtpOptions(), 500);
  }

  showGetOtpOptions(){
    this.notificationOtpService.get().subscribe({
      next: (resp: any) => {
        this.otpServicesOptions = resp;
        this.selectedOtpService = this.displayedOtpService = this.otpServicesOptions[0].value;
        this.form.get('otp_service')?.setValue(this.selectedOtpService);
      },
      error: (error: ResponseHttpError) => {
        this.customMessageService.comunicationError();
      }
    });


  }

  save(){
    this.submitted = true;
    if (this.form.invalid){
      return
    }
    this.utilService.enablePageLoading()
    this.form.value.phone = this.form.value.phone.replace(environment.global.country.phoneCountryCode, '').replace(/[^0-9 ]/g, '').replace(/ /g,'');
    let data = {...this.form.value, sales_type: this.typeSales};
    this.requestService.create(data).subscribe({
      next: (resp: ResponseHttpSuccess)=> {
        if(resp.status === HttpStatusCode.Created) {
          this.data = resp.body.data;
          if(this.data.approved == true ) {
            this.requestID = this.data.request_id;
            this.updateRequest();
            this.showView('topUpLoan');
            if (this.data.top_up_loan) {
              this.showView('topUpLoan');
            } else if (this.data.buyback) {
              this.showView('success');
            } else {
              this.onNextStep();
            }
          }else{
            this.customMessageService.logErrorOnly(resp);
            this.router.navigate([this.salesWorkflowService.getErrorNotApprovedRequestUrl()])
            this.utilService.disablePageLoading()
          }
        }else{
          this.customMessageService.responseNoticeHandler(resp);
          this.utilService.disablePageLoading()
        }
      }, error: (error: ResponseHttpError) => {
        if(error.status == HttpStatusCode.NotAcceptable) {
          this.customMessageService.logErrorOnly(error)
          this.router.navigate([this.salesWorkflowService.getErrorNotApprovedRequestUrl()], { state: {
            messageError: error.error?.message,
            attemptedUrl: this.utilService.getCurrentUrl(),
          }});
        }else{
          this.customMessageService.responseNoticeHandler(error);
        }
        this.utilService.disablePageLoading()
      }
    })
  }

  updateRequest(){
    if (this.requestID) {
      this.requestService.update(this.requestID, {update_salesman_request_id: true}).subscribe({
        error: (error: ResponseHttpError) => {
          this.customMessageService.responseNoticeHandler(error);
        }
      });
    }
  }

  private showView(viewType: 'topUpLoan' | 'success'): void {
    this.viewTopUpLoan = viewType === 'topUpLoan';
    this.viewSuccess = viewType === 'success';
    this.viewForm = false;
    this.utilService.disablePageLoading();
  }

  onNextStep() {
    let data = {
      requestId: this.data.request_id
    }
    this.nextStepEvent.emit(data);
  }

  onSelectedOtpService() {
    if (this.selectedOtpService) {
      this.form.get('otp_service')?.setValue(this.selectedOtpService);
      this.showOtpServiceModal = false;
      this.displayedOtpService = this.selectedOtpService;
    }
  }

  initForm() {
    this.form = new FormGroup({
      document_id_type: new FormControl(
        null,
        [Validators.required]
      ),
      document_id_number: new FormControl(
        null,
        [Validators.required]
      ),
      phone: new FormControl(
        null,
        {
          validators: [
            Validators.required,
            Validators.minLength(environment.global.country.minPhoneNumberCharacters),
            Validators.maxLength(environment.global.country.maxPhoneNumberCharacters)
          ],
          asyncValidators: [
            this.userValidatorService.phoneServiceExistValidator(this.requestID),
            this.userValidatorService.phoneServiceVerification()
          ],
          updateOn: 'blur'
        }
      ),
      gender: new FormControl(
        null,
        [Validators.required]
      ),
      country_code_number: new FormControl(
        environment.global.country.phoneCountryCode.replace('+', '')
      ),
      email: new FormControl(
        null,
        {
          validators: this.getEmailValidators(),
          asyncValidators: this.getEmailAsyncValidators(),
          updateOn: 'blur'
        }
      ),
      otp_service: new FormControl(
        null,
        [Validators.required]
      )
    });
  }

  get f(){
    return this.form.controls;
  }

  get isEmailRequired(): boolean {
    return (environment.global.country as any).isEmailRequired !== false;
  }

  get isMexico(): boolean {
    return environment.global.country.code === 'MX';
  }

  private getEmailValidators() {
    const validators = [Validators.email];
    if (this.isEmailRequired || this.emailRequired) {
      validators.unshift(Validators.required);
    }
    return validators;
  }

  private getEmailAsyncValidators(): AsyncValidatorFn[] {
    const existValidator = this.userValidatorService.emailServiceExistValidator();
    const statusValidator = this.userValidatorService.emailServiceStatusValid();
    if (this.isEmailRequired || this.emailRequired) {
      return [existValidator, statusValidator];
    }
    const skipIfEmpty = (validator: AsyncValidatorFn): AsyncValidatorFn =>
      (control: AbstractControl): Observable<ValidationErrors | null> =>
        control.value ? validator(control) as Observable<ValidationErrors | null> : of(null);
    return [skipIfEmpty(existValidator), skipIfEmpty(statusValidator)];
  }
}
